import AgencyBanner from './agency-banner';

export default AgencyBanner;
